var map = {
	"./ALARM.mp3": "d8bc",
	"./ALERT.mp3": "6621",
	"./BEEP.mp3": "e593",
	"./BELL.mp3": "3366",
	"./BIRD.mp3": "90fb",
	"./BUGLE.mp3": "86f2",
	"./DEFAULT.mp3": "8d95",
	"./DIGITAL.mp3": "a2be",
	"./DROP.mp3": "7fd2",
	"./HORN.mp3": "b3c2",
	"./MUSIC.mp3": "79d4",
	"./NONE.mp3": "4856",
	"./RING.mp3": "5a11",
	"./WARNING.mp3": "0144",
	"./WHISTLE.mp3": "792b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fa7";